export default {"src":"/_next/static/media/firewall-and-router-configuration-audit.5eb5e3b4.svg","height":568,"width":426,"blurWidth":0,"blurHeight":0};